import {useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {msg, t} from '@lingui/macro'
import {useLingui} from '@lingui/react'
import {styled} from '@mui/material/styles'
import {Box, IconButton} from '@mui/material/'
import ListAltIcon from '@mui/icons-material/ListAlt'
import BarChartIcon from '@mui/icons-material/BarChart'
import DesktopNav from '../../components/desktop/DesktopNav'
import Dashboard from "../../components/data-analysis/charts/Dashboard";
import CrashList from "../../components/data-analysis/CrashList";
import CustomChart from "../../components/data-analysis/charts/CustomChart";
import {DashboardOutlined} from "@mui/icons-material";
import DesktopToolbar from "../../components/desktop/DesktopToolbar";
import {Typography, useTheme} from "@mui/material";
import SvgCustomIcon from "../../components/icons/SvgCustomIcon";
import { NAV_LAYOUT_MARGIN_START } from '../../consts/nav-layout-margin'

/*
  - Crash
  Collected by
  Officer Name/Operator Name
  Officer Department/Operator Hospital
  Date of Filling <----> Until <---->
  Crash date <----> Until <---->
  Crash month
  Light conditions
  Crash type
  ADaMS crash id
  Officer position
  Officer number
  Report number
  Report date <----> Until <---->
  Crash week day
  Wheather conditions
  Vehicle runaway
  Severity
*/

// eslint-disable-next-line no-restricted-globals
const statsBaseUrl = new URL('/api/statistics', location)

// eslint-disable-next-line no-restricted-globals
const allPublicCrashesUrl = new URL('/api/public_crash/list', location)





const ExpandMore = styled(props => {
    const {expand, ...other} = props
    return <IconButton {...other} />
})(({theme}) => ({
    marginLeft: 'auto'
    , transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
    })
    , variants: [
        {
            props: ({expand}) => !expand
            , style: {
                transform: 'rotate(0deg)'
            }
        }
        , {
            props: ({expand}) => !!expand
            , style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
}));





export default function Statistics({position, isMobile, handleRowClick}) {
    const location = useLocation()
    const [showSub, setShowSub] = useState('crashList')
    const theme = useTheme()
    const {_} = useLingui()

    useEffect(() => {
        if (location.state?.highlightCrashId) {
            setShowSub('crashList')
        }
    }, [location.state?.highlightCrashId])

    const iconSizeStyle = {
        height: 20,
        width: 20
    }

    const subPanelElements = [
        {
            label: t`Crash list`
            , icon: <SvgCustomIcon name={'list'}/>
            , type: 'button'
            , onMobile: false
            , access: [0, 1, 2, 3]
            , active: showSub === 'crashList'
            , action: () => setShowSub('crashList')
        }

        , {
            label: t`Dashboard`
            , icon: <SvgCustomIcon name={'dashboard'}/>
            , type: 'button'
            , onMobile: false
            , access: [0, 1, 2, 3]
            , active: showSub === 'charts'
            , action: () => setShowSub('charts')
        }
        , {
            label: t`Custom charts`
            , icon: <SvgCustomIcon name={'barChart4'}/>
            , type: 'button'
            , onMobile: false
            , access: [0, 1, 2, 3]
            , active: showSub === 'customCharts'
            , action: () => setShowSub('customCharts')
        }
    ]

    return (
        <Box component="main">
            <DesktopNav position={position} subPanelElements={subPanelElements}/>
            <DesktopToolbar/>
            <Box sx={{ p: 2 }}>
                <Box sx={{ marginInlineStart: NAV_LAYOUT_MARGIN_START, p: 1, borderBottom: `1px solid ${theme.palette.newColors.gray}` }}>
                    <Typography sx={{color: theme.palette.mode === 'light' ? theme.palette.newColors.gray : theme.palette.newColors.lightGray,fontWeight:'bold',fontSize:24}}>
                        {_(msg`Data Analysis`)}
                    </Typography>
                </Box>
                <Box sx={{ marginInlineStart: NAV_LAYOUT_MARGIN_START, p: 1 }}>
                    <Typography sx={{textTransform:'uppercase',color: theme.palette.mode === 'light' ? theme.palette.newColors.gray : theme.palette.newColors.lightGray,fontWeight:'bold',fontSize:18}}>
                        {showSub === 'crashList' ? _(msg`Crash list`) : showSub === 'charts' ? _(msg`Dashboard`) : _(msg`Custom charts`)}
                    </Typography>
                </Box>
                {
                    {
                        crashList: <CrashList isMobile={isMobile} handleRowClick={handleRowClick}/>
                        , charts: <Dashboard isMobile={isMobile}/>
                        , customCharts: <CustomChart isMobile={isMobile}/>
                    }[showSub]
                }
            </Box>
        </Box>
    )
}
